export const ENV_ENDPOINT_VNF = "https://vnf-api.variosecure.com";

export const ENV_ENDPOINT_GAE = "https://device-api.variosecure.com";

export const ENV_DOMAIN_VDAP = "https://portal4.dataprotection.jp";

export const ENV_CP_MSS = "https://dali.variosecure.com/";

export const ENV_URL_KISHIN = "https://kishin-monitor.heroz.jp/vsr";

export const ENV_CONFIG = {
  apiKey: "AIzaSyBIIbsQ4QGvVC9znvfZBA4x5_XkicqflXE",
  authDomain: "sdns-prd-01.firebaseapp.com",
  databaseURL: "https://sdns-prd-01.firebaseio.com",
  projectId: "sdns-prd-01",
  storageBucket: "sdns-prd-01.appspot.com",
  messagingSenderId: "576838612236",
  appId: "1:576838612236:web:fe507fa8f10e83f7174529",
  measurementId: "G-GFM7ZCNCNW",
};
